import { InfoCircleFilled } from "@ant-design/icons";
import { Button, Text } from "../../../components";
import Localization from "../../../localization";
import { Flex } from "antd";
import React from "react";

const Actions = ({ activated = false, onActivate = () => {} }) => {
  return (
    <div className="p-30-t">
      {!activated ? (
        <Button
          type="primary"
          onClick={onActivate}
          title={Localization.general.activate}
        />
      ) : (
        <Flex gap={".5rem"} align="center">
          <Text level={4} type="destructive" children={<InfoCircleFilled />} />
          <Text level={5} children={Localization.activate.footer_desc} />
        </Flex>
      )}
    </div>
  );
};

export default Actions;
